<template>
	<component :is="define.component" v-bind="define.props" :_config="_config" :_parent="_parent" :_define="define"
			   :_index="_index"
			   @del-node="(v)=>$emit('del-node',v)"
			   @to-left="(v)=>$emit('to-left',v)"
			   @to-right="(v)=>$emit('to-right',v)"
			   @node-click="(v)=>$emit('node-click',v)"
	></component>
	<flow-action v-if="parentDefine?.nodes?.length >0" :nodes="parentDefine?.nodes||[]"
				 @add-node="(name)=>$emit('add-node',name)" ></flow-action>
</template>

<script>
import {getFlow} from "./flow-context";
import FlowAction from "@/components/flow/nodes/flow-action.vue";

export default {
	name: 'FlowRender',
	components: {FlowAction},
	props: {
		_config: {
			type: Object
		},
		_parent: {
			type: Object, default: () => ({})
		},
		_index: {
			type: Number
		}
	},
	setup(props) {
		const define = getFlow(props._config?.name)
		const parentDefine = getFlow(props._parent?.name)
		return {
			define,
			parentDefine
		}
	}
}
</script>

<style lang="scss" scoped>

</style>
